module.exports = __webpack_public_path__ + "static/media/ios-star-outline.7598789f.svg";